import { Component, Input } from "@angular/core";

@Component({
  selector: "upsell-wait",
  templateUrl: "upsell-wait.html",
  styleUrls: ['upsell-wait.scss'],
})

export class UpsellWaitComponent {

  @Input() iconWait: string = 'https://cdn.hartfelt.com/images/wait_icon.png';
  @Input() isFull: boolean = false;
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() kevinClasses: string = '';

  constructor() {}
}
